export default {
    path: "/",
    meta: {
      requiresAuth: false,
    },
    name: "send-money",
    component: () => import("./views/public/send-money"),
    // name: "topup-airtime-home",
    // component: () => import("./views/public/topup-airtime-stepper"),
  };